import React from 'react';
import RevealSection from '../ui/RevealSection';

const clients = [
  { name: 'Copec', logo: '/logos/copec.svg', className: 'h-8 md:h-10' },
  { name: 'Shell', logo: '/logos/shell.svg', className: 'h-10 md:h-12', noFilter: true },
  { name: 'CORFO', logo: '/logos/corfo.svg', className: 'h-12 md:h-16' },
  { name: 'Lundin Mining', logo: '/logos/lundin-mining.svg', className: 'h-8 md:h-10' },
  { name: 'Chilexpress', logo: '/logos/chilexpress.svg', className: 'h-8 md:h-10' },
];

export default function About() {
  return (
    <section id="about" className="section py-32">
      <div className="max-w-5xl mx-auto w-full">
        <div className="mb-20 text-center">
          <RevealSection>
            <p className="text-white/40 text-sm font-body font-extralight uppercase tracking-[0.3em] mb-6">
              Clientes
            </p>
          </RevealSection>
        </div>

        <RevealSection delay={0.15}>
          <div className="flex flex-wrap items-center justify-center gap-12 md:gap-20">
            {clients.map((client) => (
              <div
                key={client.name}
                className="group flex items-center justify-center"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className={`${client.className} w-auto object-contain ${client.noFilter ? '' : 'brightness-0 invert'} opacity-25 group-hover:opacity-60 transition-opacity duration-500`}
                />
              </div>
            ))}
          </div>
        </RevealSection>
      </div>
    </section>
  );
}
